import React from 'react'

export default function ForeignObject({ className }) {
  return (
    <svg
      className={`${className} w-8 h-8`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Ground/zone line the object was left on */}
      <path
        d="M2 20H22"
        stroke="#5B21B6"
        strokeWidth="1.6"
        strokeLinecap="round"
      />

      {/* Unidentified debris/object lying in the zone */}
      <path
        d="M4.5 19L4 15.6L6.7 13L10.3 13.7L11.5 16.8L9.6 19H4.5Z"
        fill="#7C3AED"
        stroke="#5B21B6"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />

      {/* Detection scan / magnifier flagging the object */}
      <circle
        cx="15.5"
        cy="8.5"
        r="4.2"
        fill="#EDE9FE"
        stroke="#7C3AED"
        strokeWidth="1.7"
      />
      <path
        d="M18.5 11.5L21.5 14.5"
        stroke="#7C3AED"
        strokeWidth="1.7"
        strokeLinecap="round"
      />

      {/* Alert mark inside the scan */}
      <path
        d="M15.5 6.3V8.9"
        stroke="#7C3AED"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <circle cx="15.5" cy="10.6" r="0.75" fill="#7C3AED" />
    </svg>
  );
}
